import { useEffect } from "react";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function LegalPageLayout({ title, testId, children }) {
  useEffect(() => {
    document.title = `${title} | AMTM Rescue Hub`;
  }, [title]);

  return (
    <div className="min-h-screen bg-amtm-bg" data-testid={testId}>
      <PublicHeader />
      <article className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <h1 className="font-display text-3xl md:text-4xl text-amtm-text mb-8">{title}</h1>
        <div className="text-amtm-textMuted leading-relaxed space-y-5 text-[15px] [&_h2]:font-display [&_h2]:text-xl [&_h2]:text-amtm-text [&_h2]:mt-8 [&_h2]:mb-1 [&_a]:text-amtm-teal [&_a]:underline [&_strong]:text-amtm-text">
          {children}
        </div>
      </article>
      <PublicFooter />
    </div>
  );
}
